module.exports = __webpack_public_path__ + "img/iconfont.451d6d18.svg";